<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <div class="app-login-container">
    <v-snackbar
      top
      :timeout="10000"
      :color="toasterMessage.mode"
      :value="toasterMessage.text"
      ref="testSnackBar"
    >
      <span v-html="toasterMessage.text" />

      <a @click.stop="toasterMessage.text = null"> Close </a>
    </v-snackbar>
    <IntentOfUseDialog
      :show-dialog="showIntentOfUse"
      :closeable="true"
      @close-intent-of-use="
        event => {
          if (event) {
            showIntentOfUse = false
          }
        }
      "
      @action="
        showIntentOfUse = false
        login()
      "
      @set-toaster="
        text => {
          toasterMessage.text = text
        }
      "
    ></IntentOfUseDialog>
    <p><img class="app-login-img" src="@/assets/EC_Centered_Logo-2x.png" /></p>
    <p class="app-login-title-text">
      simple, self-service exclusion list searches
    </p>

    <form id="loginform" @submit.prevent="showIntentOfUseBeforeLogin()">
      <h5 class="form-header">Welcome! Please log in below</h5>

      <div v-if="error != null" class="app-error-container">
        <span class="fa fa-times-circle" /> {{ error }}
      </div>

      <div class="form-input-group">
        <label for="username" class="form-label"> Username </label>
        <input
          type="text"
          v-model="credentials.username"
          id="username"
          class="form-input-text"
        />
      </div>

      <div class="form-input-group">
        <label for="password" class="form-label"> Password </label>
        <input
          v-model="credentials.password"
          type="password"
          id="password"
          class="form-input-text"
        />
      </div>

      <v-btn type="submit" class="v-btn btn-xl btn-primary"> Login </v-btn>
    </form>

    <p class="mt-1">
      <router-link to="/registration/company" title="Register" class="mr-4">
        Click here to Register
      </router-link>
      <a href="/reset-password">Forgot Password?</a>
    </p>
  </div>
</template>

<script>
import IntentOfUseDialog from "@/components/IntentOfUseDialog"

import axios from "axios"
import redirect from "@/service/redirect"

export default {
  name: "Login",
  components: {
    IntentOfUseDialog
  },

  data() {
    return {
      credentials: {
        username: "",
        password: ""
      },
      error: null,
      showIntentOfUse: false,
      toasterMessage: {
        text: null,
        mode: "error"
      }
    }
  },

  methods: {
    showIntentOfUseBeforeLogin: function() {
      this.toasterMessage.text = null
      this.showIntentOfUse = true
    },
    login: function() {
      this.error = null

      return axios
        .post("/services/user/login", {
          username: this.credentials.username,
          password: this.credentials.password
        })
        .then(response => {
          switch (response.data) {
            case "LOGIN_SUCCESSFUL":
              redirect("/")
              break
            case "WHITELIST_FAILURE":
              this.error =
                "Sorry, but your IP address is not in the permitted list specified " +
                "by your domain administrator to access ExclusionCheck."
              break
            case "TRIAL_EXPIRED":
              this.error = "Your trial period has expired"
              break
            case "ACCOUNT_DISABLED":
              this.error = "This account has been disabled"
              break
            default:
              this.error =
                "We can't seem to find the login information you've entered. " +
                "If you haven't signed up yet, please register to create an account."
              break
          }

          return response
        })
        .catch(errorResponse => {
          console.log(errorResponse)
          return errorResponse
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-login-container {
  @include app-ec-card;
  max-width: 560px;
}

.app-login-img {
  width: 300px;
}

.app-login-title-text {
  font-style: italic;
  margin-bottom: 4.5rem;
}

.app-error-container {
  text-align: left;
  background-color: $color-error-lighter;
  border: 1px solid $color-error-light;
  color: $color-error-dark;
  padding: 7px 7px 7px 0.75rem;
  margin-left: 0.5rem;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue